var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 124,
    r: 124,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.735 124.306C174.735 96.5228 152.185 74.0002 124.368 74.0002C96.5503 74.0002 74 96.5228 74 124.306C74 149.414 92.4186 170.226 116.498 174V138.847H103.709V124.306H116.498V113.223C116.498 100.615 124.017 93.6509 135.522 93.6509C141.033 93.6509 146.797 94.6334 146.797 94.6334V107.013H140.446C134.189 107.013 132.238 110.891 132.238 114.87V124.306H146.207L143.974 138.847H132.238V174C156.317 170.226 174.735 149.415 174.735 124.306Z",
    fill: "#8091B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.92cfda7a8d9582c9a83a2947600226ea.svg";
export { ForwardRef as ReactComponent };